<template>
    <b-modal id="show-modal" centered hide-footer no-close-on-backdrop size="md" class="mb-4">
        <b-alert v-if="alert.show" :variant="alert.variant" show>
            {{ alert.message }}
        </b-alert>
        <div class="row">
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.amount') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatAmount(data.amount) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.name') }}</label>
                    <div class="col-7 col-form-label">
                        {{ data.full_name }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.checkin_date') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatDate(data.checkin_date) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.checkout_date') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatDate(data.checkout_date) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.reservation') }}</label>
                    <div class="col-7 col-form-label">
                        {{ data.reservation_number }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.booking') }}</label>
                    <div class="col-7 col-form-label">
                        {{ $t(`booking_statuses.${data.booking_code}`) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.payment_authorized') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatUtcToFacilityTimezone(data.settlement_date) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.payment_captured') }}</label>
                    <div class="col-7 col-form-label">
                        {{
                            formatUtcToFacilityTimezone(data.captured_date) ?? "--"
                        }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="row">
                    <label class="col-5 col-form-label">
                        Refund Date
                    </label>
                    <div class="col-7 col-form-label">
                        {{ formatUtcToFacilityTimezone(data.refund_date) ?? "--" }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.type') }}</label>
                    <div class="col-7 col-form-label text-capitalize">
                        <!-- {{ facility_booking.charge.payment_method_details.card.brand }} {{
                            facility_booking.charge.payment_method_details.card.funding }} {{
                            facility_booking.charge.payment_method_details.type }} -->
                        Card
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.number') }}</label>
                    <div class="col-7 col-form-label text-capitalize">
                        {{ data.transaction_reference ?? "--" }}
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center mb-3"
            :class="data.refund_date == null ? 'justify-content-between' : 'justify-content-center'"
            style="max-width: 200px; margin: auto;">
            <b-button class="mt-4" pill size="md" variant="primary" @click="$bvModal.hide('show-modal')">
                {{ $t("account-page-visitor-payments.back") }}
            </b-button>

            <b-button class="mt-4" rounded size="md" variant="danger" v-if="data.refund_date === null"
                @click="refundPayment(data.transaction_reference)">
                {{ $t("account-page-visitor-payments.refund") }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import formatters from '@/mixins/formatters.js';

import {
  main_form_methods,
} from "@/modules/checkin-facility/utils/mockup";

const  { formatUtcToFacilityTimezone }= main_form_methods;

export default {
    name: "ArbitrageShow",
    data() {
        return {
            facility_booking: {
                charge: {
                    payment_method_details: {
                        card: {}
                    }
                }
            },
            data: {},
            facility: window._app_facility,
            alert: {
                show: false,
                variant: 'success',
                message: ''
            }
        }
    },
    methods: {
        formatUtcToFacilityTimezone,
        showAlert(variant, message) {
            this.alert = {
                show: true,
                variant,
                message,
            };

            setTimeout(() => {
                this.alert.show = false;
            }, 3000);
        },
        async view(val) {
            this.data = val;
            this.$bvModal.show('show-modal')
        },
        async refundPayment(transactionId) {

            const payload = {
                facility_id: this.facility.id,
                transaction_reference: transactionId
            }

            try {

                await this.$lionheart.post("/v2/dg/payment-refund", payload)
                this.$bvModal.hide('show-modal');

                // Delay slightly to allow alert to show before reload
                setTimeout(() => {
                    this.$emit('refresh-settlement');
                }, 500);

            } catch (err) {

                this.showAlert(
                    "danger",
                    this.$t("account-page-notif-control.schedule_pre_checkin_notice.sms_pre_checkin_notice.sms_error_alert")
                );
            }

        }
    },
    watch: {
        data: {
            handler(newVal, oldVal) {
                console.log('data changed:', { oldVal, newVal });
            },
            deep: true,
            immediate: false
        }
    },
    mixins: [formatters],
}
</script>

<style scoped></style>